import React, { useContext } from "react";
import { FaCheckDouble, FaBoxes, FaClipboardCheck, FaWarehouse } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/rack_stability_hero_1776820067006.png';

function RackStability() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/rack-stability');
    } else {
      navigate('/login', { state: { from: '/booking/rack-stability' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">Rack Stability Certificate</h1>
          <p className="hero-subtitle">
            Ensuring warehouse safety and optimal load capacities. Comprehensive inspections and certifications for storage racking systems.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Ensuring Safe Storage Solutions</h2>
              <p className="article-text">
                Warehouse racking systems are subjected to constant stress, heavy loads, and potential impacts from material handling equipment. A Rack Stability Certificate validates that your storage systems are structurally sound and capable of safely supporting their designated loads, minimizing the risk of collapse and workplace accidents.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Inspection Checks</h2>
              <p className="article-text">
                Our detailed assessments cover:
                <br />- <strong>Damage Assessment:</strong> Checking for bent uprights, damaged bracing, and compromised base plates.
                <br />- <strong>Load Capacity Verification:</strong> Ensuring racks are not overloaded and weight limits are clearly displayed.
                <br />- <strong>Verticality & Alignment:</strong> Checking for plumbness and straightness to prevent uneven stress distributions.
                <br />- <strong>Connection Integrity:</strong> Inspecting safety pins, bolts, and interlocking components.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Compliance and Peace of Mind</h2>
              <p className="article-text">
                Regular rack inspections and certification demonstrate a commitment to health and safety standards, keeping your workforce secure and ensuring uninterrupted warehouse operations.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Aspects</h4>
              <ul className="key-list">
                <li><FaWarehouse className="check-icon" /> Warehouse Reliability</li>
                <li><FaBoxes className="check-icon" /> Load Safety</li>
                <li><FaClipboardCheck className="check-icon" /> Detailed Assessment</li>
                <li><FaCheckDouble className="check-icon" /> Standard Compliance</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Secure Your Racks</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Prevent accidents with a certified rack inspection.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Schedule Inspection
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default RackStability;
